import options from './thing-details-folder.component';

export default {
    selector: 'dtThingDetailsFolder',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-details-folder/index.js